// Default domain constants - single source of truth for fallback domain configuration
export const DEFAULT_DOMAIN = 'llxl.de';
export const DEFAULT_SITE_URL = `https://${DEFAULT_DOMAIN}`;
export const DEFAULT_API_URL = `https://b.${DEFAULT_DOMAIN}`;
export const DEFAULT_STORAGE_URL = `https://f.${DEFAULT_DOMAIN}`;

export const siteName = `${process.env.NAME || 'Rin'} - ${process.env.DESCRIPTION || 'Blog & Tools'}`;

// Site URL: prefers env, then window.location.origin (dynamic for any custom domain / preview URL), then DEFAULT_SITE_URL
export const siteUrl =
  import.meta.env.SITE_URL ||
  import.meta.env.VITE_SITE_URL ||
  (typeof window !== 'undefined' && window.location.origin ? window.location.origin : DEFAULT_SITE_URL);

// API URL: prefers env, then local dev port, then DEFAULT_API_URL
export const apiUrl =
  import.meta.env.API_URL ||
  import.meta.env.VITE_API_URL ||
  (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://localhost:12345'
    : DEFAULT_API_URL);

// Storage URL: prefers env, then DEFAULT_STORAGE_URL
export const storageUrl =
  import.meta.env.VITE_STORAGE_URL ||
  import.meta.env.STORAGE_URL ||
  DEFAULT_STORAGE_URL;

// Normalize media and asset URLs (rewrites legacy domain references on-the-fly to current storage/site domain)
export function normalizeMediaUrl(url?: string | null): string {
  if (!url) return '';
  return url
    .replace(/https?:\/\/f\.nix\.pub/gi, storageUrl)
    .replace(/f\.nix\.pub/gi, `f.${DEFAULT_DOMAIN}`)
    .replace(/https?:\/\/b\.nix\.pub/gi, apiUrl)
    .replace(/b\.nix\.pub/gi, `b.${DEFAULT_DOMAIN}`)
    .replace(/https?:\/\/nix\.pub/gi, siteUrl)
    .replace(/nix\.pub/gi, DEFAULT_DOMAIN);
}

export const avatarUrl = normalizeMediaUrl(process.env.AVATAR || '') || '/favicon.png';
